angular.module('jv.requisition.summary.controller', [])
    .controller('ReqsSummaryCtrl', ['$scope', 'Reqs', '$location', '$filter', '$rootScope', '$route', '$window', 'transformApprovalChain', '$q', 'NOTE_MAX_LENGTH', 'jvHireUrlService',
        function ($scope, Reqs, $location, $filter, $rootScope, $route, $window, transformApprovalChain, $q, NOTE_MAX_LENGTH, jvHireUrlService) {
            var urlParams = $scope.urlParams(),
                options = {};

            $scope.properties = angular.copy($window.properties);
            var pendingFlag;
            
            $scope.requisitions.selectedPosting='select';
            $scope.$on('onReqStatusUpdate', function () {
                //update jobBoard posting data if any
                if ($scope.requisitions && $scope.requisitions.filteredjobBoards) {
                    Reqs.jobBoard($scope.params.id, function (requisition) {
                        $scope.map = prepareData(requisition);
                        $scope.requisitions.filteredjobBoards = requisition.jobBoardPost;
                        $scope.version = requisition.version;
                    });
                }
            });

            function prepareData(postingData) {
                $scope.resp = postingData; // eslint-disable-line block-scoped-var
                $scope.arr = $scope.resp.jobBoardPost;
                var map = {};
                for (var i = 0; i < $scope.arr.length; i++) {
                    var postingData = $scope.arr[i]; // eslint-disable-line no-redeclare
                    var postingArr = map[postingData.jobTargetId];

                    if (typeof postingArr === 'undefined') {
                        postingArr = [];
                        map[postingData.jobTargetId] = postingArr;
                    }
                    postingArr.push(postingData);
                }
                return map;
            }

            function setApprovalChain(approvalChain) {
                approvalChain = transformApprovalChain(approvalChain);
                if ($scope.requisitions) {
                    $scope.requisitions.approvalChains = approvalChain.reverse();
                }
            }

            var setupSections = function () {
                $scope.sections = [{
                        key: 'hiredCandidates',
                        page: 'tabs/hired.html',
                        visible: $scope.requisitions.views.hiredCandidates
                    },
                    {
                        key: 'interviewSummary',
                        page: 'tabs/interviews.html',
                        visible: $scope.requisitions.views.interviewSummary
                    },
                    {
                        key: 'candidateWorkFlowStates',
                        page: 'tabs/workflow.html',
                        visible: $scope.requisitions.views.candidatePipeline
                    },
                    {
                        key: 'approvalChains',
                        page: 'tabs/approvalChain.html',
                        visible: $scope.requisitions.views.approvalChain
                    },
                    {
                        key: 'jobBoardPost',
                        page: 'tabs/jobBoard.html',
                        visible: $scope.requisitions.views.jobBoardSummary
                    },
                    {
                        key: 'linkedinJobPosting',
                        page: 'tabs/linkedinJobPosting.html',
                        visible: $scope.requisitions.views.linkedinJobPosting
                    },
                    {
                        key: 'vonqCampaignSummary',
                        page: 'tabs/vonqCampaign.html',
                        visible: $scope.requisitions.views.actions.postToVonq
                    }
                ];
            };
            //Method to handle URL redirection from Req to cand
            $scope.getAppDetailsUrl = function (hired) {
                window.location.href = jvHireUrlService.getApplicationDetailsUrl(hired);
            };

            $scope.hasApproverNotes = false;
            $scope.flags.loading = true;

            $scope.removePostModal = {
                show: false,
                ok: function () {
                    $scope.removeAllPostings($scope.currentModal.boardName);
                    $scope.removePostModal.show = false;
                },
                cancel: function () {
                    $scope.removePostModal.show = false;
                },

                okTitle: i18n.REMOVE,
                cancelTitle: i18n.REQ_DELETE_CANCEL,
                title: i18n.REQS_DELETE_ALL_JOBPOSTINGS,
                body: i18n.REQS_DELETEJOBPOSTINGS_CONFIRM
            };

            $scope.activeBoard = 'All';
            // These booleans indicate if the data has already been fetched from server once(which is done on the first click).
            $scope.upcomingPagin = {
                low: 1,
                total: 10,
                pageSize: 10,
                high: this.pageSize,
                next: function () {
                    if (this.low + this.pageSize > this.total) {
                        return;
                    }
                    this.low = this.low + this.pageSize;
                    this.high = this.high + this.pageSize > this.total ? this.total : this.high + this.pageSize;
                },
                prev: function () {
                    if (this.low <= this.pageSize) {
                        return;
                    }
                    this.low = this.low - this.pageSize < 1 ? 1 : this.low - this.pageSize;
                    this.high = this.low + this.pageSize - 1;
                }
            };

            $scope.pastPagin = {
                low: 1,
                total: 10,
                pageSize: 10,
                high: this.pageSize,
                next: function () {
                    if (this.low + this.pageSize > this.total) {
                        return;
                    }
                    this.low = this.low + this.pageSize;
                    this.high = this.high + this.pageSize > this.total ? this.total : this.high + this.pageSize;
                },
                prev: function () {
                    if (this.low <= this.pageSize) {
                        return;
                    }
                    this.low = this.low - this.pageSize < 1 ? 1 : this.low - this.pageSize;
                    this.high = this.high - this.pageSize < this.pageSize ? this.pageSize : this.high - this.pageSize;
                }
            };

            // VBTODO: Why is this invocation made for every case, an unnecessary AJAX request which only hampers the performance.

            if ($scope.activeTab('#/summary')) {
                options = {
                    id: $scope.params.id,
                    index: $scope.params.index,
                    count: $scope.params.count,
                    paginated: $scope.flags.paginated
                };

                if (urlParams.hasOwnProperty('readMode')) {
                    options.readMode = urlParams.readMode;
                } else if ($scope.$parent.fastRead) {
                    options.readMode = '0';
                    delete $scope.$parent.fastRead;
                }

                var fetchReqDetails = function () {
                    var deferred = $q.defer();
                    Reqs.details(options, function (requisition) {

                        if (requisition.forumBaseUrl) {
                            $scope.$root.forumBaseUrl = requisition.forumBaseUrl;
                        }
                        angular.extend($scope.requisitions, requisition);

                        $scope.params.id = $scope.requisitions.jobDetails.EId;

                        setupSections();

                        if ($scope.flags.paginated) {
                            $scope.flags.paginated = false;
                        }
                        //Fetch the notes count only if the notes tab is visible
                        if (requisition.views.notesTab) {
                            Reqs.getNotesCount($scope.params.id, function (response) {
                                $scope.$parent.requisitions.notesCount = response.notesCount;
                            });
                        }
                        if (!$scope.requisitions.views.summaryTab) {
                            $scope.routeRequest($scope.params, 1);
                            return;
                        }
                        
                        // Dirty quickfix for 8980 untill BE come up with their fix
                        if (requisition.msgInfo && requisition.msgInfo !== 410) {
                            $scope.showMsg(requisition.msgInfo);
                        }
                        var search = $location.search();
                        if (!!search && search.code) {
                            $scope.showMsg(search.code);
                        }
                        deferred.resolve($scope.params.id);
                    });
                    return deferred.promise;
                };


                if (options.id) {
                    Reqs.getPaginationCount(options, function () {
                        // empty function
                    });
                }

                /**
                 * Customising Recruiter Campaign User Flow by removing unwanted components. - DELTA-1488
                 */
                var customizeVonqCampaignFlow = function (){
                    window.addEventListener('hapi:load:script', () => {
                        window.hapi.orderJourney.state.stepsEnabled = window.hapi.orderJourney.state.stepsEnabled.value.filter(
                            (key) => key !== window.hapi.orderJourney.utils.stepKeys.addContracts && key !== window.hapi.orderJourney.utils.stepKeys.postingUTMCodes && key !== window.hapi.orderJourney.utils.stepKeys.selectContracts
                        );
                    });
                };

                var vonqAuthentication = function (companyEID) {
                    Reqs.vonqAuth(companyEID, function(result){
                        const scriptEl = document.createElement('script');
                        scriptEl.setAttribute('defer','');
                        scriptEl.src = result.vonqAuthResponse.hapiElementURL + '?clientId=' + result.vonqAuthResponse.clientId + '&clientToken=' + result.vonqAuthResponse.clientToken + '&partnerId=' + result.vonqAuthResponse.partnerId;
                        scriptEl.setAttribute('charset', 'utf-8');
                        document.head.appendChild(scriptEl);
                    });
                };


                var fetchReqSummary = function (reqEId) {
                    $scope.drawBarChart = false;
                    Reqs.summary(reqEId, function (requisitions) {
                        //setting the forumbaseurl
                        var interviewData, sectionCount = $scope.sections.length;
                        //redirect to new search page with filters if new candidate search enabled
                        //making sure we load the page if $scope.requisitions.jobDetails is not available. If $scope.requisitions.jobDetails is not available it will still create link to application search page but without req selected.
                        if ($scope.requisitions && $scope.requisitions.jobDetails) {
                            var totalCandidatesObject = {
                                'jobs': {
                                    'reqEId': $scope.requisitions.jobDetails.EId,
                                    'reqName': $scope.requisitions.jobDetails.title
                                }
                            };
                            $scope.encodedTotalCandidates = $window.LZString.compressToEncodedURIComponent(JSON.stringify(totalCandidatesObject));

                            var activeCandidatesObject = {
                                'jobs': {
                                    'reqEId': $scope.requisitions.jobDetails.EId,
                                    'reqName': $scope.requisitions.jobDetails.title
                                },
                                'workflowStateId': -1
                            };
                            $scope.encodedActiveCandidates = $window.LZString.compressToEncodedURIComponent(JSON.stringify(activeCandidatesObject));
                        }
                        $scope.$parent.forumBaseUrl = requisitions.forumBaseUrl;
                        // Delete data from previous requisition. Old requisition data persists during pagination.
                        for (var i = 0; i < sectionCount; i++) {
                            if ($scope.requisitions && $scope.requisitions[$scope.sections[i].key]) {
                                delete $scope.requisitions[$scope.sections[i].key];
                            }
                        }
                        $scope.isSuperUser = window._jvselfUser.roles.indexOf('ROLE_SUPERUSER') !== -1;
                        if (angular.isDefined(requisitions.hiredCandidates) && requisitions.hiredCandidates.length > 0) {
                            requisitions.hiredCandidates.map(isCandidateDetailEditable);
                        }
                        angular.extend($scope.requisitions, requisitions);
                        Reqs.jobBoard(reqEId, function (requisition) {
                            angular.extend($scope.requisitions, requisition);
                            $scope.map = prepareData(requisition);
                            $scope.requisitions.filteredjobBoards = requisition.jobBoardPost;
                            $scope.version = requisition.version;
                        }, options.readMode);

                        // Draw 'candidate by workflow step' chart on this flag true to avoid chart rendering before response.
                        $scope.drawBarChart = true;

                        if (requisitions.tabIndex !== 0) {
                            $scope.routeRequest($scope.params, requisitions.tabIndex);
                            return;
                        }
                        $scope.summaryRendered = true;
                        $scope.flags.loading = false;

                        if ($scope.requisitions && $scope.requisitions.views.approvalChain && $scope.requisitions.jobDetails && $scope.requisitions.jobDetails.jobState !== 'Draft') {
                            if ($window.location.search.indexOf('readMode=0') !== -1 || options.readMode === '0') {
                                Reqs.getApprovalChain($scope.requisitions.jobDetails.EId, setApprovalChain);
                            } else {
                                Reqs.getApprovalChain($scope.requisitions.jobDetails.EId, setApprovalChain, true); // true removes readMode=0 from URL
                            }
                        }

                        if ($scope.requisitions.interviewSummary) {
                            interviewData = $scope.requisitions.interviewSummary;
                            if (interviewData.interviewState === 0) {
                                $scope.upcomingClicked = true;
                                if (interviewData.pastInterview) {
                                    $scope.requisitions.showPastLink = true;
                                }
                                $scope.requisitions.showUpcomingLink = true;
                                $scope.requisitions.visibleInterviews = 'Upcoming';
                                $scope.requisitions.upcomingInterviews = interviewData;
                            } else {
                                $scope.pastClicked = true;
                                $scope.requisitions.showPastLink = true;
                                $scope.requisitions.visibleInterviews = 'Past';
                                $scope.requisitions.pastInterviews = interviewData;
                            }
                            $scope.pastPagin.high = $scope.upcomingPagin.high = $scope.requisitions.interviewSummary.candidatesCount < 10 ? $scope.requisitions.interviewSummary.candidatesCount : 10;
                            $scope.pastPagin.total = $scope.upcomingPagin.total = $scope.requisitions.interviewSummary.candidatesCount;
                        }
                        $scope.requisitions.tabIndex = requisitions.tabIndex;
                        if($scope.requisitions.actionLinks.postToVonq){
                            customizeVonqCampaignFlow();
                            vonqAuthentication($window.companyEID);
                        }
                    }, options.readMode);
                    $scope.drawChart = false;
                    $scope.$watch('requisitions.sourceType', function (newValue) {
                        if (newValue && $scope.requisitions.views.analytics) {
                            Reqs.analytics($scope.params.id, function (requisition) {
                                $scope.drawChart = true;
                                angular.extend($scope.requisitions, requisition);
                            }, options.readMode);
                        }
                    }, true);
                };

                fetchReqDetails().then(function (reqEId) {
                    fetchReqSummary(reqEId);
                });
            }

            /**
             * Method to check whether candidate details on requisition page should be editable by checking its startdate
             * startdate should be greater than current date(Fix for #HIRE-15087)
             *
             * @param eachCandidate
             */
            function isCandidateDetailEditable(eachCandidate) {
                if (!$scope.isSuperUser) {
                    if (angular.isDefined(eachCandidate.startDate)) {
                        eachCandidate.hideEdit = eachCandidate.startDate < $rootScope.getTodayDateUserTimezone().getTime();
                        return;
                    }
                }
                eachCandidate.hideEdit = false;
            }

            /**
             *
             *
             * @param section
             * @returns {Boolean}
             */
            $scope.isKeyPresent = function (section) {
                var val;
                
                if ($scope.requisitions && section.key in $scope.requisitions && section.visible) {
                    val = $scope.requisitions[section.key];
                    if (!(Array.isArray(val) && val.length === 0) && !$.isEmptyObject(val)) {
                        return true;
                    }
                }
                return false;
            };

            /**
             *
             * Checks if a approval is closed or pending.
             *
             * @param section Approval object.
             * @returns {Boolean} true if the approval is closed, otherwise false.
             */
            $scope.isApprovalClosed = function (approval) {
                return !!approval.statusName;
            };

            $scope.jobBoards = [{
                    name: 'LinkedIn',
                    clickThrough: 100,
                    startDate: 12 / 2 / 2012
                },
                {
                    name: 'Naukri',
                    clickThrough: 100,
                    startDate: 12 / 2 / 2012,
                    expireDate: 12 / 2 / 2012
                },
                {
                    name: 'Monster',
                    clickThrough: 100,
                    startDate: 12 / 2 / 2012,
                    expireDate: 12 / 2 / 2012
                }
            ];


            $scope.expandInterview = function (candidate) {
                if (candidate.expanded) {
                    candidate.expanded = false;
                    return;
                }
                if (typeof candidate.details === 'undefined') {
                    var mode;
                    if ($scope.requisitions.pastInterviews && $scope.requisitions.pastInterviews.interviewState === 1 && $scope.pastClicked) {
                        mode = 1;
                    } else {
                        mode = 0;
                    }
                    Reqs.interviewDetails($scope.requisitions.jobDetails.EId, candidate.EId, mode, function (response) {
                        candidate.interviewTypes = response.interviewTypes[candidate.EId];
                        candidate.expanded = true;
                    });
                } else {
                    candidate.expanded = true;
                }
            };

            $scope.expandAllInterviews = function () {
                var mode;
                if ($scope.requisitions.pastInterviews && $scope.requisitions.pastInterviews.interviewState === 1 && $scope.pastClicked) {
                    $scope.interviewType = 'pastInterviews';
                    mode = 1;
                } else {
                    $scope.interviewType = 'upcomingInterviews';
                    mode = 0;
                }
                if ($scope.requisitions[$scope.interviewType].candidates.length) {
                    var length = $scope.requisitions[$scope.interviewType].candidates.length;
                    var canDetails, candidateEidArr = [];
                    for (var i = 0; i < length; i++) {
                        if (!$scope.requisitions[$scope.interviewType].candidates[i].details) {
                            //build array and do ajax call
                            canDetails = false;
                            candidateEidArr.push($scope.requisitions[$scope.interviewType].candidates[i].EId);
                        } else {
                            canDetails = true;
                            $scope.requisitions[$scope.interviewType].candidates[i].expanded = true;
                        }
                    }
                    if (!canDetails) {
                        Reqs.interviewDetails($scope.params.id, candidateEidArr, mode, function (response) {
                            angular.extend([], $scope.requisitions[$scope.interviewType].candidates);
                            angular.forEach($scope.requisitions[$scope.interviewType].candidates, function (candidate, key) {
                                $scope.requisitions[$scope.interviewType].candidates[key].interviewTypes = response.interviewTypes[candidate.EId];
                            });
                            $scope.expandAll($scope.requisitions[$scope.interviewType].candidates);
                        });
                    }
                }
            };

            $scope.pastPrev = function () {
                $scope.pastPagin.prev();
                Reqs.interviewPaginate({
                    id: $scope.requisitions.jobDetails.EId,
                    low: $scope.pastPagin.low,
                    mode: 1
                }, function (response) {
                    $scope.requisitions.pastInterviews = response.interviewSummary;
                });
            };

            $scope.pastNext = function () {
                $scope.pastPagin.next();
                Reqs.interviewPaginate({
                    id: $scope.requisitions.jobDetails.EId,
                    low: $scope.pastPagin.low,
                    mode: 1
                }, function (response) {
                    $scope.requisitions.pastInterviews = response.interviewSummary;
                });
            };

            $scope.upcomingPrev = function () {
                $scope.upcomingPagin.prev();
                Reqs.interviewPaginate({
                    id: $scope.requisitions.jobDetails.EId,
                    low: $scope.upcomingPagin.low,
                    mode: 0
                }, function (response) {
                    $scope.requisitions.upcomingInterviews = response.interviewSummary;
                });
            };

            $scope.upcomingNext = function () {
                $scope.upcomingPagin.next();
                Reqs.interviewPaginate({
                    id: $scope.requisitions.jobDetails.EId,
                    low: $scope.upcomingPagin.low,
                    mode: 0
                }, function (response) {
                    $scope.requisitions.upcomingInterviews = response.interviewSummary;
                });
            };

            $scope.showUpcomingInterviews = function () {
                // Fetch data from server the first time it is clicked.
                if (!$scope.upcomingClicked) {
                    Reqs.interviewPaginate({
                        id: $scope.requisitions.jobDetails.EId,
                        low: 1,
                        mode: 0
                    }, function (response) {
                        $scope.requisitions.upcomingInterviews = response.interviewSummary;
                    });
                    $scope.upcomingClicked = true;
                    $scope.pastClicked = false;
                }
                $scope.requisitions.visibleInterviews = 'Upcoming';
            };

            $scope.showPastInterviews = function () {
                // Fetch data from server the first time it is clicked.
                if (!$scope.pastClicked) {
                    Reqs.interviewPaginate({
                        id: $scope.requisitions.jobDetails.EId,
                        low: 1,
                        mode: 1
                    }, function (response) {
                        $scope.requisitions.pastInterviews = response.interviewSummary;
                        $scope.pastPagin.high = response.interviewSummary.candidatesCount < 10 ? response.interviewSummary.candidatesCount : 10;
                        $scope.pastPagin.total = response.interviewSummary.candidatesCount;
                    });
                    $scope.pastClicked = true;
                    $scope.upcomingClicked = false;
                }
                $scope.requisitions.visibleInterviews = 'Past';
            };

            //For modifying the jobBoard posting details
            $scope.modifyPosting = function (jobBoardId) {
                Reqs.modifyJobTargetPosting({
                    j: $scope.requisitions.jobDetails.EId,
                    jobBoardId: jobBoardId
                }, function (response) {
                    $scope.requisitions.jobBoardActionMSG = response.msgInfo;
                });

            };

            //For removing the jobBoard posting details
            $scope.removeEQuestPosting = function () {
                Reqs.removeFromEQuest($scope.requisitions.jobDetails.EId, function (response) {
                    var eQuestData = JSON.parse(response.bean),
                        eQuestParamMap = JSON.parse(eQuestData.result);
                    var form = $('<form/>').attr({
                        name: 'eQuestPostForm',
                        action: 'https://jobvite.equest.com/post/',
                        target: '_self',
                        method: 'POST'
                    });
                    for (var key in eQuestParamMap) {
                        var input = $('<input/>').attr({
                                type: 'hidden'
                            }),
                            name = eQuestParamMap[key].Id,
                            value = eQuestParamMap[key].Value;
                        if (name === 'return_url' || name === 'error_url') {
                            value = response.jhireBaseUrl + '/action/requisition/' + $scope.requisitions.jobDetails.EId + '/jobboard/eQuest?deleted=true&i=' + $scope.params.index + '&c=' + $scope.params.count + '&q=' + $scope.params.query;
                        }
                        input.attr({
                            name: name,
                            value: value
                        });
                        form.append(input);
                    }
                    $('#container').append(form);
                    document.eQuestPostForm.submit();
                });
            };


            $scope.removePostingsModal = function (name) {
                $scope.currentModal = $scope.removePostModal;
                $scope.currentModal.boardName = name;
                $scope.currentModal.show = true;
                $scope.currentModal.body = $scope.format(i18n.REQS_DELETEJOBPOSTINGS_CONFIRM, name);
            };

            //Bulk removal of jobBoard posting details
            $scope.removeAllPostings = function (name) {
                pendingFlag = true;
                if (name === 'jobTarget') {
                    $scope.flags.loading = true;
                    Reqs.removeJobTargetPosting({
                        j: $scope.requisitions.jobDetails.EId,
                        isAllPending: setPendingFlag()
                    }, function (response) {
                        if (response.msgInfo === 200) {
                            $scope.flags.loading = false;
                            $scope.showMsg('SUCCESSFULLY_REMOVED');
                            /*Making call to refresh the section with readMode=0*/
                            Reqs.jobBoard($scope.params.id, function (requisition) {
                                angular.extend($scope.requisitions, requisition);
                                $scope.map = prepareData(requisition);
                                $scope.requisitions.filteredjobBoards = requisition.jobBoardPost;
                                $scope.version = requisition.version;
                            }, true);

                        } else {
                            $scope.flags.loading = false;
                            $rootScope.error = i18n.UNABLE_TO_PERFORM_OPERATION;
                        }

                    });
                } else {
                    $scope.removeEQuestPosting();
                }
            };

            /**
             * Method to show reject modal
             */
            $scope.rejectModal = function () {
                $scope.requisitions.rejectNote = '';
                $scope.requisitions.rejectModal = true;
                $scope.requisitions.rejectNoteMaxLength = NOTE_MAX_LENGTH;
            };

            /**
             * Method to show approve modal.
             */
            $scope.approveModal = function () {
                $scope.requisitions.approveNote = '';
                $scope.requisitions.approveModal = true;
                $scope.requisitions.approveNoteMaxLength = NOTE_MAX_LENGTH;

            };

            /**
             * Method to show sendToAlternate modal.
             */
            $scope.sendApproval = {};
            $scope.openApprovalmodal = function (resend) {
                $scope.sendApproval.resend = resend;
                $scope.flags.loading = true;
                Reqs.getApproverMessageTemplate({
                    resend: resend,
                    jobEId: $scope.params.id
                }, function (response, code) {
                    if (response && code === 200) {
                        $scope.flags.loading = false;
                        $scope.sendApproval.content = response.messageDataItem.content;
                        $scope.sendApproval.subject = response.messageDataItem.subject;
                        var toList = [];
                        angular.forEach(response.messageDataItem.to, function (value) {
                            toList.push(value.fullName);
                        });
                        $scope.sendApproval.to = toList.join(',');
                        $scope.sendApproval.show = true;
                    } else {
                        // error!
                    }

                });

            };

            $scope.submitApprovalRequest = function (resendToAlternates) {
                $scope.flags.loading = true;
                var data = {
                    subject: $scope.sendApproval.subject,
                    message: $scope.sendApproval.content,
                    resendToAlternates: resendToAlternates
                };
                Reqs.sendApprovalMessage($scope.params.id, data, function (response, code) {
                    $scope.flags.loading = false;
                    if (response.msgInfo === 200 && code === 200) {
                        $scope.sendApproval.show = false;
                        $scope.sendApproval = {};
                        if (resendToAlternates) {
                            $scope.showMsg('ALTERNATE_SENT');
                        } else {
                            $scope.showMsg('REQUEST_RESEND');
                        }
                        $route.reload();
                    }
                });
            };

            var goToListPage = function () {
                return $window.jvUrls.jhire + '/modules/requisitions/list.html';
            };

            /**
             * Method to approve the requisition.
             */
            $scope.approve = function () {
                $scope.requisitions.approveModal = false;
                $scope.flags.loading = true;
                Reqs.approve({
                        j: $scope.requisitions.jobDetails.EId,
                        notes: $scope.requisitions.approveNote
                    }, function (response) {
                        if (response.msgInfo === $scope.status.OK) {
                            if (response.hasJobAccess) {
                                $scope.showMsg('approved');
                                $scope.$parent.fastRead = true;
                                $route.reload();
                            } else {
                                //If the user does not have job access, move them to the list page.
                                $window.location = goToListPage();
                            }
                        } else {
                            $scope.requisitions.approveModal = false;
                            $scope.requisitions.approvalActionError = true;
                        }
                    },
                    'summary');
            };

            /**
             * Method to reject the requisition.
             */
            $scope.reject = function () {
                $scope.requisitions.rejectModal = false;
                $scope.flags.loading = true;
                Reqs.approve({
                        j: $scope.requisitions.jobDetails.EId,
                        notes: $scope.requisitions.rejectNote,
                        reject: true
                    }, function (response) {
                        if (response.msgInfo === $scope.status.OK) {
                            if (response.hasJobAccess) {
                                $scope.showMsg('rejected');
                                $scope.$parent.fastRead = true;
                                $scope.requisitions.rejectModal = false;
                                $route.reload();
                            } else {
                                //If the user does not have job access, move them to the list page.
                                $window.location = goToListPage();
                            }
                        } else {
                            $scope.requisitions.rejectModal = false;
                            $scope.requisitions.approvalActionError = true;
                        }
                    },
                    'summary');
            };

            //skip approval
            $scope.skipApproval = function (approverId) {
                var data = {
                    j: $scope.requisitions.jobDetails.EId,
                    a: approverId,
                    readMode: 0
                };
                $scope.flags.loading = true;
                Reqs.skipApprove(data, function (response) {
                    $scope.showMsg('APPROVER_SKIPPED');
                    if (response.msgInfo === $scope.status.OK) {
                        angular.extend($scope.requisitions, response);
                        Reqs.getApprovalChain(response.jobDetails.EId, setApprovalChain);
                    } else {
                        $scope.requisitions.approvalActionError = true;
                    }
                    $scope.flags.loading = false;
                });

            };

            //equest count
            $scope.equestCount = function (jobboards) {
                jobboards = jobboards || [];
                var eQuestJobBords = $filter('filter')(jobboards, {
                    boardType: 'equest'
                }) || [];
                return eQuestJobBords.length || 0;
            };

            //filter job boards
            $scope.filterJobBoards = function (boardType) {
                $scope.activeBoard = boardType;
                var filter = {
                    boardType: 'eQuest'
                };
                switch (boardType) {
                    case 'eQuest':
                        filter = {
                            boardType: 'eQuest'
                        };
                        break;
                    case 'jobTarget':
                        filter = function (board) {
                            return !board.boardType || board.boardType === 'eQuest';
                        };
                        break;
                    default:
                        filter = {};
                        break;
                }
                $scope.requisitions.filteredjobBoards = $filter('filter')($scope.requisitions.jobBoardPost, filter);
            };
            $scope.isRetractedOrRejected = function (approvers) {
                for (var approver in approvers) {
                    if (approvers[approver].statusKind === 'RETRACTED' || approvers[approver].statusKind === 'REJECTED') {
                        $scope.displayStatusName = approvers[approver].statusName;
                        $scope.displayStatusDate = approvers[approver].updated;
                        return true;
                    }
                }
                return false;
            };
            $scope.countStatus = function () {
                var active = 0;
                var pending = 0;
                angular.forEach($scope.requisitions.filteredjobBoards, function (v) {
                    switch (true) {
                        case /active/ig.test(v.status):
                            active++;
                            break;
                        case /expired/ig.test(v.status):
                            break;
                        case /pending/ig.test(v.status):
                            pending++;
                            break;
                        default:
                            // do nothing
                    }
                });
                if (active > 0 || pending > 0) {
                    return true;
                }

                return false;
            };
            $scope.checkPending = function (jobBoard) {
                return /pending/ig.test(jobBoard.status) || (jobBoard.status && jobBoard.status !== 'onHold');
            };
            $scope.calculateTimeToHire = function (hired, type) {
                if (hired && hired.sentDate && hired.hireDate) {
                    var dateDiff = $rootScope.dateDiff(hired.sentDate, hired.hireDate, type);
                    if (dateDiff >= 0){
                        return dateDiff;
                    } else {
                        return '--';
                    }
                }
            };
            $scope.totalClicks = 0;
            $scope.setTotals = function (jobboard) {
                if (jobboard) {
                    $scope.totalClicks += jobboard.clickThroughs;
                    var status = jobboard.status;
                    var dispStatus = status.split('-');
                    $scope.displayStatus = dispStatus[1];
                    $scope.status = dispStatus[0];
                }
            };

            function setPendingFlag() {
                pendingFlag = true;
                angular.forEach($scope.requisitions.filteredjobBoards, function (v) {
                    if (v.startDate && !angular.isUndefined(v.startDate) && v.startDate !== '') {
                        pendingFlag = false;
                    }
                });
                return pendingFlag;
            }

            $scope.redirectViewUrl = function (viewUrl) {
                $window.open(viewUrl);
            };

            $scope.removeJobPostingModal = function (name, postingId, jobTargetId) {
                $scope.currentModal = $scope.removeJobPostModal;
                $scope.currentModal.boardName = name;
                $scope.postingId = postingId;
                $scope.jobTargetId = jobTargetId;
                $scope.currentModal.show = true;
                $scope.currentModal.body = $scope.format(i18n.REQS_DELETE_SINGLE_POSTING_CONFIRM, name);
            };

            $scope.removeJobPostModal = {
                show: false,
                ok: function () {
                    $scope.removeJobPosting($scope.currentModal.boardName, $scope.postingId, $scope.jobTargetId);
                    $scope.removeJobPostModal.show = false;
                },
                cancel: function () {
                    $scope.removeJobPostModal.show = false;
                },
                okTitle: i18n.REMOVE,
                cancelTitle: i18n.REQ_DELETE_CANCEL,
                title: i18n.REQS_DELETE_SINGLE_JOBPOSTING,
                body: i18n.REQS_DELETE_SINGLE_POSTING_CONFIRM
            };

            $scope.removeJobPosting = function (name, postingId, jobTargetId) {
                if (name === 'jobTarget') {
                    $scope.flags.loading = true;
                    Reqs.removeJobTargetPosting({
                        j: $scope.requisitions.jobDetails.EId,
                        isAllPending: setPendingFlag(),
                        postingId: postingId,
                        jobTargetId: jobTargetId
                    }, function (response) {
                        if (response.msgInfo === 200) {
                            $scope.flags.loading = false;
                            $scope.showMsg('SUCCESSFULLY_REMOVED');
                            /*Making call to refresh the section with readMode=0*/
                            Reqs.jobBoard($scope.params.id, function (requisition) {
                                angular.extend($scope.requisitions, requisition);
                                $scope.map = prepareData(requisition);
                                $scope.requisitions.filteredjobBoards = requisition.jobBoardPost;
                                $scope.version = requisition.version;
                            }, true);
                        } else {
                            $scope.flags.loading = false;
                            $rootScope.error = i18n.UNABLE_TO_PERFORM_OPERATION;
                        }
                    });
                } else {
                    $scope.removeEQuestPosting();
                }
            };

            $scope.editJobPostingModal = function (name, jobTargetId) {
                $scope.jobTargetId = jobTargetId;
                $scope.currentModal = $scope.editJobPostModal;
                $scope.currentModal.boardName = name;
                $scope.currentModal.show = true;
                $scope.currentModal.body = $scope.format(i18n.REQS_EDITJOBPOSTINGS_CONFIRM, name);
            };

            $scope.editJobPostModal = {
                show: false,
                ok: function () {
                    $scope.editJobPosting($scope.currentModal.boardName, $scope.jobTargetId);
                    $scope.editJobPostModal.show = false;
                },
                cancel: function () {
                    $scope.editJobPostModal.show = false;
                },
                okTitle: i18n.EDIT,
                cancelTitle: i18n.REQ_DELETE_CANCEL,
                title: i18n.REQS_EDIT_ALL_JOBPOSTINGS,
                body: i18n.REQS_EDITJOBPOSTINGS_CONFIRM
            };

            $scope.editJobPosting = function (name, jobTargetId) {
                pendingFlag = true;
                if (name === 'jobTarget') {
                    $scope.flags.loading = true;
                    Reqs.modifyJobTargetPosting({
                        j: $scope.requisitions.jobDetails.EId,
                        jobTargetId: jobTargetId
                    }, function (response) {
                        if (response.manageurl != null) {
                            $scope.flags.loading = false;
                            $window.open(response.manageurl);
                        } else {
                            $scope.flags.loading = false;
                            $rootScope.error = i18n.UNABLE_TO_PERFORM_OPERATION;
                        }
                    });
                } else {
                    $scope.removeEQuestPosting();
                }
            };

            $scope.checkExpiredPosting = function (jobBoard) {
                return /expired/ig.test(jobBoard.status) || jobBoard.remove;
            };

            $scope.getLinkedInPremiumJobPostStatus = function() {
                Reqs.getLinkedInPremiumJobPostStatus($scope.requisitions.jobDetails.EId  ,function(response) {
                    if(response) {
                            $scope.requisitions.linkedinJobPosting = response;
                    }
                });
           };
           
           
           

     
          

           
        }
    ]);